'use client'

import { ScreenshotBeautifierProvider } from './ScreenshotBeautifierContext'
import { ScreenshotBeautifierControls } from './ScreenshotBeautifierControls'
import { ScreenshotBeautifierPreview } from './ScreenshotBeautifierPreview'

/**
 * Root generator component for the Screenshot Beautifier tool.
 * Composes provider, controls, and preview into the final layout consumed by the resource page.
 *
 * @returns {JSX.Element} Generator layout
 */
export const ScreenshotBeautifierGenerator = (): JSX.Element => {
  return (
    <ScreenshotBeautifierProvider>
      <div className="flex w-full flex-col gap-8 lg:flex-row">
        <div className="w-full lg:w-[420px]">
          <ScreenshotBeautifierControls />
        </div>
        <div className="flex-1">
          <ScreenshotBeautifierPreview />
        </div>
      </div>
    </ScreenshotBeautifierProvider>
  )
}
